import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import moment from 'moment';
export const isSameCentury = (date)=>Math.floor(date.get('year') / 100) === Math.floor(moment().get('year') / 100);
export const isSameYear = (date)=>moment().isSame(date, 'year');
export const humaiseYear = (date)=>isSameYear(date) ? '' : isSameCentury(date) ? date.format('YY') : date.format('YYYY');
export const humanise = (date, showYear = false, showApostrophe = false)=>date.format(`DD MMM${!moment().isSame(date, 'year') || showYear ? isSameCentury(date) ? ` ${showApostrophe ? "'" : ''}YY` : ' YYYY' : ''}`);
export const humaniseWithTime = (date)=>{
    return date.format(`DD MMM${!moment().isSame(date, 'year') ? isSameCentury(date) ? ' YY' : ' YYYY' : ''} HH:mm`);
};
export const humaniseElapsedTime = (date)=>{
    return moment(date).fromNow();
};
export const HumanisedDate = ({ timestamp })=>/*#__PURE__*/ _jsx(_Fragment, {
        children: humanise(timestamp)
    });
export const humaniseWithDay = (date)=>date.format(`ddd DD MMM${!moment().isSame(date, 'year') ? isSameCentury(date) ? ' YY' : ' YYYY' : ''}`);
export const HumanisedDateAndTime = ({ timestamp })=>{
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: humaniseWithTime(timestamp)
    });
};
export const HumaniseElapsedTime = ({ timestamp })=>{
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: humaniseElapsedTime(timestamp)
    });
};
